const app = require('app');
// The primary purpose of this function is to work in tandem with the server's BusinessLogicException to convey server side errors to users.
// It's current state should be considered a first pass. It would be nice if it could be integrated with saveModelBehavior.
module.exports = function (view, response, reload) {
    let errorCallback;
    if (view.hasServerValidationFailures && view.hasServerValidationFailures(response) && view.showServerValidationErrors) {
        errorCallback = () => view.showServerValidationErrors(response);
    }
    else if (response.responseJSON && response.responseJSON.businessLogicErrors) {
        _.forEach(response.responseJSON.businessLogicErrors, function (error) {
            errorCallback = () => app.notifyError(error);
        })
    }
    else {
        errorCallback = () => app.notifyError('Error');
    }
    if (reload) {
        Backbone.history.once('route', errorCallback);
        Backbone.history.loadUrl();
    }
    else {
        errorCallback();
    }
}